<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted } from 'vue';
    import axios from 'axios';
import { MARKET_COMMANDE_MOTIF_REJET, MARKET_COMMANDE_MOTIF_REJET_OPTIONS_GROUPED } from '@/utils';

    const props = defineProps({});
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const commande = reactive({
        id: null as number | null,
        num_commande: '',
        created_at: '',
        user: {
            nom: '',
            prenom: '',
        }
    });
    const formData = reactive({
        motif_rejet_commande: 'CLIENT_REQUEST',
        commentaire_rejet_commande: '',
    });
    const errors = reactive({
        motif_rejet_commande: '',
        commentaire_rejet_commande: '',
    });

    async function open(_commande: any) {
        Object.assign(commande, _commande);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.motif_rejet_commande = '';
        if (!formData.motif_rejet_commande) {
            errors.motif_rejet_commande = "Le motif de rejet est requis";
            isValid = false;
        }

        if (formData.motif_rejet_commande === MARKET_COMMANDE_MOTIF_REJET.OTHER && !formData.commentaire_rejet_commande) {
            errors.commentaire_rejet_commande = "Le commentaire est requis lorsque le motif de rejet est 'Autre'";
            isValid = false;
        } else {
            errors.commentaire_rejet_commande = '';
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                commande_id: commande.id,
                motif_rejet_commande: formData.motif_rejet_commande,
                commentaire_rejet_commande: formData.commentaire_rejet_commande,
            };

            const httpResponse = await axios.post(`/backoffice/market-commandes/reject/${commande.id}`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <div style="flex: 1; display: flex; flex-direction:row; justify-content: space-between;">
                <h4 class="font-semibold">Rejeter la commande</h4>
            </div>
        </template>
        <div>
            <div class="form-field-floating reactive my-4">
                <input type="text" class="form-input" :value="commande.num_commande" name="num_commande" id="num_commande" placeholder="" autocomplete="off" readonly="true">
                <label for="num_commande">Num Commande <b class="color-danger">*</b></label>
            </div>
            <div class="form-field-floating reactive my-4">
                <input type="text" class="form-input" :value="commande.user.nom + ' ' + commande.user.prenom" name="user_nom" id="user_nom" placeholder="" autocomplete="off" readonly="true">
                <label for="user_nom">Membre <b class="color-danger">*</b></label>
            </div>
            <div class="form-field-floating full my-5">
                <select class="form-input-select" v-model="formData.motif_rejet_commande" name="motif_rejet_commande" id="motif_rejet_commande">
                    <optgroup v-for="(reasonCategory, index) in MARKET_COMMANDE_MOTIF_REJET_OPTIONS_GROUPED" :key="'reason_category_' + index" :label="reasonCategory.category">
                        <option :value="reason.code" v-for="(reason, reasonIndex) in reasonCategory.reasons" :key="'reason_' + reasonIndex">
                            {{ reason.label }}
                        </option>
                    </optgroup>
                </select>
                <label for="motif_rejet_commande">Motif <b class="color-danger">*</b></label>
                <span v-if="!!errors['motif_rejet_commande']" class="text-red">{{ errors['motif_rejet_commande'] }}</span>
            </div>
            <div v-if="formData.motif_rejet_commande === 'OTHER'">
                <div class="form-field-floating reactive my-4">
                    <textarea class="form-input lg" v-model="formData.commentaire_rejet_commande" name="commentaire_rejet_commande" id="commentaire_rejet_commande" rows="3"></textarea>
                    <label for="commentaire_rejet_commande">Commentaire <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['commentaire_rejet_commande']" class="text-red">{{ errors['commentaire_rejet_commande'] }}</span>
            </div>

        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onSubmit">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
</template>
